import { useController, Control } from "react-hook-form";
import { DatePicker, DatePickerProps } from "../input/components/date-picker";

type Props = {
  name: string;
  control?: Control<any>;
  DatePickerProps?: Partial<DatePickerProps>;
};

export function DatePickerController(props: Props) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control
  });

  const helperText = fieldState.error?.message || props.DatePickerProps?.helperText;

  return (
    <DatePicker
      {...field}
      error={fieldState.invalid}
      helperText={helperText}
      {...props.DatePickerProps}
    />
  );
}
